<script>
	import { colorMain, api_writeDwell, api_writeForm } from "./stores.js";
	import Icon from "@iconify/svelte";
	import nextFilled from "@iconify/icons-carbon/next-filled";
	import { updateNextRoute, writeForm } from "./utils.js";
	import { fly } from "svelte/transition";
	import IntersectionObserver from "svelte-intersection-observer";

	let element;
	export let FeedType = "scroll";

	console.log("checkpoint");
	writeForm($api_writeForm, {
		checkpoint: "feed-entity-idx-final",
	});

	// const formRoute = "/form/crt";  // where to redirect to after submit
	let formRoute = localStorage.getItem("nextRoute");
	console.log("Submit.svelte next formRoute:", formRoute);
	// formRoute = ""; // for testing to turn off redirect

	let startTime = Number(localStorage.getItem("startTime"));

	// sort objects in array by key
	const sortByKey = (array, key) => {
		return array.sort(function (a, b) {
			var x = a[key];
			var y = b[key];
			return x < y ? -1 : x > y ? 1 : 0;
		});
	};
	async function writeBatchDwell() {
		// in case of iframe, send message to parent frame
		window.parent.postMessage("submitClicked", "*");

		console.log("checkpoint");
		writeForm($api_writeForm, {
			checkpoint: "feed-entity-idx-submit-click",
		});
		updateNextRoute();
		let entities = prepareData();

		console.log("Writing dwelltimes for all entities...");
		const resp = await fetch($api_writeDwell, {
			method: "POST",
			mode: "cors",
			cache: "default",
			headers: {
				"Content-Type": "application/json",
				Accept: "application/json",
			},
			body: JSON.stringify({
				user_id: localStorage.getItem("user_id"),
				condition: localStorage.getItem("condition"),
				experiment_id: localStorage.getItem("experiment_id"),
				dwell_data: entities,
			}),
		});

		const response = await resp.json();
		if (response.success === "true") {
			console.log("Write batch data successfully");
		} else {
			console.log("Fail to write/post batch data");
		}
		if (response) {
			if (
				formRoute !== undefined &&
				formRoute !== "" &&
				formRoute !== null
			) {
				window.location.replace(formRoute);
			}
		}
	}

	const prepareData = () => {
		const time = +new Date();
		let entities_engage = Object.values(
			JSON.parse(localStorage.getItem("entities_engage")),
		);
		entities_engage = sortByKey(entities_engage, "idx");
		let keysSelect = [
			"idx",
			"entity_id",
			"dwells",
			"dwellTimes",
			"dwellsInviewTime",
		];

		// select multiple keys from each object in an array
		console.log("Prepare entities/dwelltimes for batch write");
		let entitiesParsed = [];
		for (let i in entities_engage) {
			// compute dwelltimes for last few entities there are never out of view (for the last few cards); to facilitate trial-by-trial analyses
			const ent = entities_engage[i];
			if (ent.dwells === 0 && i >= entities_engage.length - 2) {
				const dwellTime = time - ent.lastViewTime;
				entities_engage[i].dwells++;
				entities_engage[i].dwellTimes.push(dwellTime);
				entities_engage[i].dwellsInviewTime.push(ent.lastViewTime);
			} else if (ent.dwells === 0 && i < entities_engage.length - 2) {
				// if no dwell detected, send dwellTime = 0 and find last inview entity's inview time
				entities_engage[i].dwells++;
				// entities_engage[i].dwells = -9999; // for debuggin
				entities_engage[i].dwellTimes.push(0);
				let lastInviewTime = -1;
				let idx = i;
				while (lastInviewTime <= 0) {
					idx--;
					if (idx == 0) {
						entities_engage[i].dwellsInviewTime.push(startTime);
						break;
					}
					let previousInviewTimes =
						entities_engage[idx].dwellsInviewTime;
					if (previousInviewTimes.length > 0) {
						lastInviewTime =
							previousInviewTimes[previousInviewTimes.length - 1];
						entities_engage[i].dwellsInviewTime.push(
							lastInviewTime,
						);
						break;
					}
				}
			}

			// get selected properties in each object
			let subset = keysSelect.reduce(function (o, k) {
				o[k] = entities_engage[i][k];
				return o;
			}, {});
			entitiesParsed.push(subset);
		}
		console.log("entitiesParsed", entitiesParsed);
		// writeBatchDwell(entitiesParsed);
		return entitiesParsed;
	};
</script>

<IntersectionObserver {element} let:intersecting>
	<div bind:this={element}>
		{#if intersecting}
			<div class="submit" in:fly={{ y: 144, duration: 987 }}>
				<p class="tooltiptext">Click to continue</p>
				<p
					on:click={writeBatchDwell}
					class="submit-icon pulse hvr-pulse"
				>
					<Icon icon={nextFilled} width="55" color={$colorMain} />
				</p>
			</div>
		{/if}
	</div>
</IntersectionObserver>

{#if FeedType == "swipe"}
	<style>
		.submit {
			margin: 0px;
			padding: 0px;
			text-align: center;
		}
		.tooltiptext {
			margin: 0px;
			padding-bottom: 0.3rem;
		}
		.submit-icon {
			margin: 0px;
			padding: 0px;
		}
	</style>
{:else}
	<style>
		.submit {
			margin: 89px;
		}
		.submit-icon {
			cursor: pointer;
		}
	</style>
{/if}
